import {
    REQUEST_INQUIRY_LIST
} from './mutation-types';

export default {
  [REQUEST_INQUIRY_LIST] (state, receivedData) {
    state.inquiryList = receivedData.content;
    state.inquiryCount = receivedData.totalElements
  },
}